import type { FormSettings } from '../form-settings'

export function resolveFormComponentName(
  formId: string,
  settings?: FormSettings
) {
  return settings?.template || formId
}
